import apiClient from './apiClient';

const dashboardService = {
  /**
   * Fetch dashboard statistics
   * @param {string} [period] - 'This Week' | 'This Month' | 'This Year'
   */
  fetchStats: async (period) => {
    const params = period ? { period } : {};
    const response = await apiClient.get('/dashboard/stats', { params });
    return response.data;
  },

  /**
   * Fetch recent activity
   */
  fetchRecentActivity: async () => {
    const response = await apiClient.get('/dashboard/activity');
    return response.data;
  }
};

export default dashboardService;
